import { useState } from 'react';
import { IS_WEB } from '@/utils/platform';

export function useOnHover(disabled?: boolean | undefined) {
  const [isHovered, setHovered] = useState(false);

  const handleHoverIn = () => {
    if (IS_WEB) setHovered(disabled ? false : true);
  };

  const handleHoverOut = () => {
    if (IS_WEB) setHovered(false);
  };

  return {
    isHovered,
    handleHoverIn,
    handleHoverOut,
  };
}
